var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-login-note"},[_vm._v("\n  ご購入いただくためにはLedianの会員登録が必要です。\n  すでにLedianに登録済みの方はログインしてください。\n")])}
var staticRenderFns = []

export { render, staticRenderFns }